import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import ImgSignupConfirm from 'legacy/assets/img/signup-confirm.png'
import { ButtonAction } from 'legacy/components/Button/ButtonAction'
import { FormAlert } from 'legacy/components/FormAlert/FormAlert'
import { I18n } from 'legacy/components/I18n/i18n'
import { resetAccountPassword } from 'legacy/services/account'
import { screen } from 'legacy/styles/screen'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const Title = styled.h2`
  width: 100%;
  margin: 0;
  margin-bottom: 24px;
  padding-bottom: 20px;

  color: ${getToken('color-neutral-darkest')};
  font-weight: bold;
  font-size: 22px;
  line-height: 24px;
  text-align: center;

  border-bottom: 1px solid ${getToken('color-neutral-light')};
`

const Text = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0 20px;

  font-size: 14px;
  line-height: 20px;
  text-align: center;
`

const StyledAlert = styled(FormAlert)`
  margin-bottom: 10px;

  color: ${getToken('color-danger-dark')};

  background-color: ${getToken('color-danger-light')};
`

const Button = styled(ButtonAction)`
  flex-basis: 100%;
  margin-top: 10px;

  ${screen.md} {
    flex-basis: 48%;
  }
`

function ForgotPasswordSuccess(props) {
  const { email, onClose } = props
  const [loading, setLoading] = useState(false)
  const [hasError, setHasError] = useState(false)

  const handleResendEmail = useCallback(async () => {
    setLoading(true)
    setHasError(false)

    const data = { email }

    try {
      await resetAccountPassword(data)
    } catch (error) {
      setHasError(true)
    } finally {
      setLoading(false)
    }
  }, [setLoading, setHasError, email])

  return (
    <Container>
      <Title>{I18n.get('lb.outletDialog.forgotPassword.success.title')}</Title>
      <img src={ImgSignupConfirm} alt="Check your email" width="180px" height="185px" />
      <Text>{I18n.get('lb.outletDialog.forgotPassword.success.text')}</Text>
      {hasError && <StyledAlert message={I18n.get('lb.outletDialog.forgotPassword.error')} />}
      <Button
        type="button"
        width="100%"
        size="sm"
        disabled={loading}
        onClick={handleResendEmail}
        activated
        square
        upperCase
      >
        {I18n.get('lb.outletDialog.signUp.success.resendEmail')}
      </Button>
      <Button type="button" width="100%" size="sm" onClick={onClose} square upperCase>
        {I18n.get('lb.outletDialog.forgotPassword.cancel')}
      </Button>
    </Container>
  )
}

ForgotPasswordSuccess.displayName = 'ForgotPasswordSucess'

ForgotPasswordSuccess.propTypes = {
  email: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

ForgotPasswordSuccess.defaultProps = {}

export { ForgotPasswordSuccess }
